export const LOCALHOST_BASE_URL = "https://localhost:7006";
export const AWS_BASE_URL = "https://app.semmapp.com";
//old---export const AWS_STAGE_BASE_URL = "http://18.141.38.194:1133";
export const AWS_STAGE_BASE_URL = "https://app.kaulassociates.com.pk";
export const LOCAL_SERVER_STAG_BASE_URL = "http://192.168.100.2:8031";
export const CACHE_CONTROL = "no-cache, no-store, must-revalidate";
export const PRAGMA = "no-cache";
